export default "__VITE_ASSET__DAwIzvTI__"